export default "/images/10fa68faaa526229e9771ff7fbf19736.jpg";